import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { UserAvatarPlaceholder } from '../../../../icons/UserAvatarPlaceholder'

export function Facilitator({ facilitator, removeFacilitator }) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <button
        key={facilitator.id}
        onClick={() => removeFacilitator(facilitator.id)}
        className="h-[38px] px-2 py-1 bg-white rounded-lg shadow border border-grey-200 flex items-center gap-2 relative"
      >
        {facilitator.picture ? (
          <img className="w-[32px] h-[32px] rounded-full border border-grey-200" src={facilitator.picture} />
        ) : (
          <UserAvatarPlaceholder />
        )}
        <p className="text-[#40424A] text-sm font-semibold font-['Manrope'] leading-tight pr-5 truncate">
          {facilitator.name?.trim() || 'Unnamed'}
        </p>
        {isHovered && (
          <div className="absolute right-2 flex items-center justify-center bg-white">
            <svg width="16" height="16" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.6673 9.33398L9.33398 18.6673"
                stroke="#40424A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.33398 9.33398L18.6673 18.6673"
                stroke="#40424A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
      </button>
    </div>
  )
}

Facilitator.propTypes = {
  facilitator: PropTypes.object,
  removeFacilitator: PropTypes.func,
}
